/*
 * PZ Wishlist JS — localStorage-based
 */
(function () {
  var KEY = 'pz_wishlist';

  var WL = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } },
    set: function (l) { localStorage.setItem(KEY, JSON.stringify(l)); },
    has: function (id) { return this.get().indexOf(String(id)) > -1; },
    add: function (id) { var l = this.get(); if (!this.has(id)) { l.push(String(id)); this.set(l); } },
    remove: function (id) { this.set(this.get().filter(function (x) { return x !== String(id); })); },
    toggle: function (id) { if (this.has(id)) { this.remove(id); return false; } else { this.add(id); return true; } },
    count: function () { return this.get().length; }
  };

  window.PZWishlist = WL;

  function toast(msg) {
    var t = document.getElementById('pz-wl-toast');
    if (!t) { t = document.createElement('div'); t.id = 'pz-wl-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._tmr);
    t._tmr = setTimeout(function () { t.classList.remove('show'); }, 2500);
  }

  function syncButtons(id, active) {
    document.querySelectorAll('.pz-wl-btn[data-id="' + id + '"]').forEach(function (b) {
      b.classList.toggle('active', active);
    });
  }

  function initButtons() {
    document.querySelectorAll('.pz-wl-btn[data-id]').forEach(function (btn) {
      btn.classList.toggle('active', WL.has(btn.dataset.id));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pz-wl-btn[data-id]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.id;
    var added = WL.toggle(id);
    syncButtons(id, added);
    toast(added ? '\u2665 Added to wishlist' : 'Removed from wishlist');
  });

  function injectProductPageBtn() {
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.pz-wl-product-row')) return;
    var pid = form.querySelector('[name="id"]');
    if (!pid) return;
    var id = form.closest('[data-product-id]') ? form.closest('[data-product-id]').dataset.productId : null;
    if (!id) {
      var meta = document.querySelector('script[type="application/json"][id*="product"]');
      if (meta) { try { id = JSON.parse(meta.textContent).id; } catch(e){} }
    }
    if (!id) return;
    var row = document.createElement('div');
    row.className = 'pz-wl-product-row';
    row.innerHTML =
      '<button class="pz-wl-btn" data-id="' + id + '" aria-label="Add to wishlist">'+
        '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>'+
      '</button>'+
      '<a href="/pages/wishlist">View Wishlist</a>';
    form.parentNode.insertBefore(row, form.nextSibling);
    row.querySelector('.pz-wl-btn').classList.toggle('active', WL.has(id));
  }

  function injectCardBtns() {
    document.querySelectorAll('.pz-t2-card[data-id], .card-wrapper[data-id]').forEach(function (card) {
      if (card.querySelector('.pz-wl-btn')) return;
      var id = card.dataset.id;
      var wrap = document.createElement('div');
      wrap.className = 'pz-card-wl';
      wrap.innerHTML =
        '<button class="pz-wl-btn" data-id="' + id + '" aria-label="Add to wishlist">'+
          '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>'+
        '</button>';
      card.style.position = 'relative';
      card.insertBefore(wrap, card.firstChild);
      wrap.querySelector('.pz-wl-btn').classList.toggle('active', WL.has(id));
    });
  }

  function renderWishlistPage() {
    var container = document.getElementById('pz-wishlist-container');
    if (!container) return;
    var ids = WL.get();
    if (!ids.length) return;
    container.innerHTML = '<div class="pz-wlpg__grid" id="pz-wl-grid"></div>';
    var grid = document.getElementById('pz-wl-grid');
    ids.forEach(function (id) {
      fetch('/search/suggest.json?q=id:' + id + '&resources[type]=product&resources[limit]=1')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          if (!products || !products.length) return;
          var p = products[0];
          var card = document.createElement('div');
          card.className = 'pz-wl-card';
          card.dataset.pid = id;
          card.innerHTML =
            '<button class="pz-wl-card__rm" data-remove="' + id + '" aria-label="Remove">'+
              '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'+
            '</button>'+
            (p.featured_image.url ?
              '<a href="' + p.url + '" class="pz-wl-card__img"><img src="' + p.featured_image.url + '" alt="' + p.title + '" loading="lazy"></a>' : '') +
            '<div class="pz-wl-card__body">'+
              (p.vendor ? '<div class="pz-wl-card__vendor">' + p.vendor + '</div>' : '') +
              '<a href="' + p.url + '" class="pz-wl-card__name">' + p.title + '</a>'+
              '<div class="pz-wl-card__price">' + (parseInt(p.price) / 100).toFixed(2) + ' EGP</div>'+
              '<button class="pz-wl-card__atc" data-vid="' + (p.variants && p.variants[0] ? p.variants[0].id : '') + '">Add to Cart</button>'+
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {});
    });
    grid.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var pid = rm.dataset.remove;
        WL.remove(pid);
        var c = grid.querySelector('[data-pid="' + pid + '"]');
        if (c) c.remove();
        if (!grid.children.length) container.innerHTML = '<div class="pz-wlpg__empty"><p>Your wishlist is empty.</p><a href="/collections/all">Continue Shopping &rarr;</a></div>';
      }
      var atc = e.target.closest('[data-vid]');
      if (atc && atc.dataset.vid) {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: atc.dataset.vid, quantity: 1 }) })
          .then(function () { toast('\u2705 Added to cart!'); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    injectProductPageBtn();
    injectCardBtns();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    initButtons();
    injectCardBtns();
  });
})();
